import { Loading } from '@/components/ui/loading';

/**
 * Full page loading component with progress bar
 * Follows Linear/Notion/Vercel Dashboard style using shadcn/ui
 */
const LoadingComponent = () => {
  return <Loading fullPage />;
};

export default LoadingComponent;
